
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArchivePage = lazy(() => import('../pages/blog-archive/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const DisclaimerPage = lazy(() => import('../pages/disclaimer/page'));
const SecurityPolicyPage = lazy(() => import('../pages/security-policy/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog/:id',
    element: <BlogPage />,
  },
  {
    path: '/blog-archive',
    element: <BlogArchivePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/security-policy',
    element: <SecurityPolicyPage />,
  },
];

export default routes;
